/**
 * 文章/博客 API
 */
import { apiClient } from './client';

/** 获取热门文章（取前3篇） */
export async function getHotArticles(config) {
    return apiClient.get('/article/hot', config);
}

/** 获取文章分类列表 */
export async function getArticleCategories(config) {
    return apiClient.get('/article/categories', config);
}

/** 分页获取文章列表 */
export async function getArticleList(params = {}) {
    return apiClient.get('/article/list', { params });
}

/** 获取文章详情 */
export async function getArticleDetail(id, config) {
    return apiClient.get(`/article/${id}`, config);
}

/** 对外统一导出 */
export const articleApi = {
    hot: getHotArticles,
    categories: getArticleCategories,
    list: getArticleList,
    detail: getArticleDetail,
};